import {useQuery } from "react-query";
import {getJsonServer} from "../../axios/generic-api2-calls";
import {TeamModel, TeamResultsModel} from "./TeamTypes";


export function useFetchTeams(key: string = 'team') {
    return useQuery<TeamModel[]>(key, () => getJsonServer('/team'));
}

export function useFetchTeam(slug: string, key: string = 'team') {
    return useQuery<TeamModel>(key, async () => (await getJsonServer(`/team?slug=${slug}`))[0]);
}

export function useFetchTeamResults(teamIdOrSlug: string|number, key: string = 'team-results') {
    return useQuery<TeamResultsModel[]>(key, () => getJsonServer(`/teams/${teamIdOrSlug}/results`));
}







